module.exports = __webpack_public_path__ + "static/img/banner-2.31f5e757.png";